<template>
  <div id="BotList">
    <a id="brand_link" href="https://www.germanchatterbox.com">
    <img src="/img/chatterboxbanner7.png" width="100%" >
    </a>

    <p>Available Bots:  {{bots.length || 'Retrieving Bot List..'}}</p>
    <div class="cards">
      <bot-card
        @click.native="openBot(name)"
        v-for="bot in bots"
        :key="bot.name"
        :image_url="bot.image_url"
        :related_page="bot.related_page"
        :name="bot.name"
      />
    </div>
    <!--
    <ul id="bot_listing">
    <li v-for="{name, profile_image} in bots" :key="name">
      <router-link :to="{ name: 'Bot', params: {bot_name: name}}">{{name}}</router-link>
    </li>
  </ul>
  -->
  </div>
</template>

<script>
    import axios from 'axios'
    import BotCard from '../components/BotCard'

    export default {
        name: "BotList",
        components: {BotCard},
        data() {
            return {
                bots: []
            }
        },
        methods: {
            async get_bot_list() {
              let server = "chat.germanchatterbox.com";
              let get_bot_list_url = `https://${server}/fun/get_bot_list?latest=yes`;

              try {
                 const botlist = await axios.get(get_bot_list_url);
                //    console.dir(botlist.data);
                    this.bots = botlist.data;
                } catch (e) {
                // eslint-disable-next-line
                    console.warn("Error whilst getting Bot list:");
                // eslint-disable-next-line
                    console.warn(e);
                }
            },
            openBot(name) {
                this.$router.push({name: 'Bot', params: {bot_name: name}});
            }
        },

        async created() {
            this.get_bot_list();
        }
    }
</script>
<style>
  #app {
    overflow-y: scroll; 
    height: 100%;
  }
</style>
<style scoped>
  .cards {
    display: grid;
    overflow: auto;
    align-self: center;
    align-items: center;
    align-content: space-evenly;
    justify-content: space-evenly;
    grid-gap: 5px;

  }
  #BotList {
/*    display: grid; */
    grid-gap: 1px;
    justify-items: center;
    align-content: center;
    align-self: center;
    align-items: center;
    vertical-align: center;
    font-size: 1.5rem;
    font-family: "Trebuchet MS", "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", sans-serif;
  /*  max-height: 99vh; /* ensure we have scollable content! */
    overflow: auto;
  }
  #brand_link {
    width: 70%;
  }
  #brand_link img {
    width: 90%;
  }
</style>
